import React, { useState, useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-natural' : 'bg-white'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex items-center justify-between h-20">
          {/* Logo/Name */}
          <RouterLink
            to="/"
            className="text-2xl font-bold text-dark-brown hover:text-primary transition-colors relative inline-block"
          >
            <span className="relative">
              Neel Parek<span className="relative inline-block">h
                <svg
                  className="absolute -bottom-1 left-0 w-full"
                  viewBox="0 0 40 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  preserveAspectRatio="none"
                >
                  <path
                    d="M2 8C8 4, 32 4, 38 8"
                    stroke="#5DCDF1"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
            </span>
          </RouterLink>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <RouterLink
              to="/podcasts"
              className="text-gray-brown hover:text-primary transition-colors font-medium"
            >
              Podcasts
            </RouterLink>

            {isHome ? (
              <ScrollLink
                to="franchise"
                smooth={true}
                duration={500}
                offset={-80}
                className="text-gray-brown hover:text-primary transition-colors cursor-pointer font-medium"
              >
                Contact
              </ScrollLink>
            ) : (
              <RouterLink
                to="/#franchise"
                className="text-gray-brown hover:text-primary transition-colors font-medium"
              >
                Contact
              </RouterLink>
            )}

            {/* CTA Button */}
            <a
              href="https://maidthisfranchise.com"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-primary text-white px-6 py-2.5 rounded-xl font-semibold hover:bg-opacity-90 transition-all shadow-sm hover:shadow-md"
            >
              Check out MaidThis Franchise
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-dark-brown"
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMobileMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden py-4 border-t border-gray-200 space-y-3">
            <RouterLink
              to="/podcasts"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block py-2 text-gray-brown hover:text-primary transition-colors font-medium"
            >
              Podcasts
            </RouterLink>

            {isHome ? (
              <ScrollLink
                to="franchise"
                smooth={true}
                duration={500}
                offset={-80}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block py-2 text-gray-brown hover:text-primary transition-colors cursor-pointer font-medium"
              >
                Contact
              </ScrollLink>
            ) : (
              <RouterLink
                to="/#franchise"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block py-2 text-gray-brown hover:text-primary transition-colors font-medium"
              >
                Contact
              </RouterLink>
            )}

            <a
              href="https://maidthisfranchise.com"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block bg-primary text-white px-6 py-3 rounded-xl font-semibold hover:bg-opacity-90 transition-all text-center"
            >
              Check out MaidThis Franchise
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
